import script from "./related-offers-grid.vue?vue&type=script&setup=true&lang=ts"
export * from "./related-offers-grid.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__